import auth from "../../middlewares/auth";

export const billingRoutes = [
    {
        path: '/billing/:slug?',
        component: () => import(/* webpackChunkName: "billings" */ '../../views/billing/BillingIndex.vue'),
        name: 'billing',
        props: true,
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/billing/:id/:date',
        component: () => import(/* webpackChunkName: "billings" */ '../../views/billing/InvoiceDetails.vue'),
        name: 'billing_invoice',
        props: true,
        meta: {
            middleware: [
                auth
            ]
        }
    },
]